import './Cards.scss';
import Card from '../card/Card';

export default function Cards({cards}) {

    return (
      <>
        <div className="cards">
            { cards.map((card) => (
                <Card>
                    <h3 className="margin-bottom-20">{card.title}</h3>
                    <p>{card.text}</p>
                </Card>
            ))}
        </div>
    </>
    );
  }